import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ExternalLink } from "lucide-react";
import { detectBrokerageKey, getBrokerGuides } from "@/data/brokerGuides";
import BrokerGuideContent from "@/components/BrokerGuideContent";
import { T, useLanguage, useT } from "@/lib/translation";
import { localizePath } from "@/lib/localizedPaths";

interface BrokerageGuideModalProps {
  open: boolean;
  onClose: () => void;
  brokerage: string | null | undefined;
}

export default function BrokerageGuideModal({
  open,
  onClose,
  brokerage,
}: BrokerageGuideModalProps) {
  const t = useT();
  const language = useLanguage();
  const key = detectBrokerageKey(brokerage);
  const guide = getBrokerGuides(language).brokerGuides[key];

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {guide
              ? t("import:brokerageGuide.titleBroker", {
                  broker: guide.brokerName,
                })
              : t("import:brokerageGuide.titleCsv")}
          </DialogTitle>
        </DialogHeader>

        {!guide ? (
          <div className="py-4 space-y-3 text-sm text-muted-foreground">
            <p>
              <T
                k="import:brokerageGuide.fallbackExport"
                components={{
                  strong: <strong className="text-foreground" />,
                }}
              />
            </p>
            <p>
              <T
                k="import:brokerageGuide.fallbackHelp"
                components={{
                  helppage: (
                    <a
                      href={localizePath("/help", language)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary underline underline-offset-2 inline-flex items-center gap-1"
                    />
                  ),
                  ext: <ExternalLink className="h-3 w-3" />,
                }}
              />
            </p>
          </div>
        ) : (
          <BrokerGuideContent guide={guide} />
        )}
      </DialogContent>
    </Dialog>
  );
}
